<template>
  <div v-if="showNavBar">
    <ul id="top_menu">
      <li class="main-menu btn_currency">
        <ul>
          <li class="m-0">
            <span>
              <b-link
                href="#"
                class="mt-2 pr-0"
              >
                <span>{{ $globalPrices[currency].symbol }}</span>
              </b-link>
            </span>

            <ul style="min-width: auto">
              <li
                v-for="(currency_data, id) in $globalPrices"
                :key="id"
                style="margin: 0; float: none;"
              >
                <b-link
                  href="#"
                  style="color: #555; font-size: .75rem"
                  @click="setPreferences('currency',id)"
                >
                  <img
                    :src="currencyFlag(id)"
                    class="flag_icon"
                  >
                  <b class="pr-1">{{ currency_data.symbol }} </b>
                  {{ $t('lang.navbar.currency_'+id) }}
                </b-link>
              </li>
            </ul>
          </li>
        </ul>
      </li>
      <li v-if="!showLoggedInNavBarComponents && !showComingSoon">
        <b-link
          ref="loginBtn"
          href="#"
          class="login"
          title="Sign In"
          @click="setShowAuthModal('login')"
        >
          {{ $t('lang.navbar.login') }}
        </b-link>
      </li>

      <li v-if="!showLoggedInNavBarComponents">
        <button
          ref="registerBtn"
          class="btn_add register"
          @click="setShowAuthModal('register')"
        >
          {{ $t('lang.navbar.register') }}
        </button>
      </li>
    </ul>

    <!-- WEB MENU (WIDTH > 992PX)   -->
    <nav
      id="menu"
      class="main-menu"
    >
      <ul v-if="showLoggedInNavBarComponents">
        <li>
          <span><b-link href="#">{{ $t('lang.navbar.user_account') }}</b-link></span>
          <ul>
            <li>
              <a :href="`/${this.$store.state.main.lang}/bookings`">
                {{ $t('lang.navbar.bookings') }}</a>
            </li>
            <li>
              <a :href="`/${this.$store.state.main.lang}/account`">
                {{ $t('lang.navbar.user_profile') }}</a>
            </li>
            <li>
              <b-link
                href="#"
                @click="logout"
              >
                {{ $t('lang.navbar.logout') }}
              </b-link>
            </li>
          </ul>
        </li>
      </ul>

      <ul>
        <li>
          <span>
            <b-link
              href="#"
              class="language_icon"
            >{{ $t('lang.navbar.language') }}
            </b-link></span>

          <ul>
            <li>
              <b-link
                href="#"
                @click="setPreferences('language','en')"
              >
                <img
                  src="../../assets/img/flags/england.png"
                  class="flag_icon"
                >English
              </b-link>
            </li>
            <li>
              <b-link
                href="#"
                @click="setPreferences('language','es')"
              >
                <img
                  src="../../assets/img/flags/spain.png"
                  class="flag_icon"
                >Español
              </b-link>
            </li>
            <li>
              <b-link
                href="#"
                @click="setPreferences('language','it')"
              >
                <img
                  src="../../assets/img/flags/italy.png"
                  class="flag_icon"
                >Italiano
              </b-link>
            </li>
            <li>
              <b-link
                href="#"
                @click="setPreferences('language','pt')"
              >
                <img
                  src="../../assets/img/flags/portugal.png"
                  class="flag_icon"
                >Português
              </b-link>
            </li>
          </ul>
        </li>

        <li>
          <span>
            <b-link
              href="#"
              class="currency_icon"
            >
              <span>{{ $globalPrices[currency].symbol }}</span>
            </b-link>
          </span>

          <ul>
            <li
              v-for="(currency_data, id) in $globalPrices"
              :key="id"
            >
              <b-link
                href="#"
                @click="setPreferences('currency',id)"
              >
                <img
                  :src="currencyFlag(id)"
                  class="flag_icon"
                >
                <b class="pr-1">{{ currency_data.symbol }} </b> {{ $t('lang.navbar.currency_'+id) }}
              </b-link>
            </li>
          </ul>
        </li>

        <li>
          <span><a
            :href="`/${this.$store.state.main.lang}/full-help`"
            target="_blank"
            class="language_icon"
          >{{ $t('lang.titles.help') }}</a></span>
        </li>
      </ul>
    </nav>

    <!-- MOBILE MENU (WIDTH < 992PX)   -->
    <div>
      <nav
        id="mySidenav"
        class="main-menu mm-menu
              mm-offcanvas mm-hasnavbar-bottom-1
              mm-pagedim-black mm-theme-dark overflow-auto"
        :class="{'opened': isOpen}"
      >
        <div class="mm-panels">
          <div
            id="mm-1"
            class="mm-panel mm-hasnavbar mm-opened"
          >
            <div class="mm-navbar">
              <a
                class="mm-title"
                :href="`/${this.$store.state.main.lang}/`"
              >{{ $t('lang.navbar.home') }}</a>
            </div>

            <ul class="mm-listview">
              <li @click="langOpen = true">
                <em class="mm-counter">2</em>
                <b-link
                  href="#"
                  class="mm-next"
                  title="Lenguaje"
                  style="width: 100%;"
                />
                <span class="mr-0">{{ $t('lang.navbar.language') }}</span>
              </li>

              <li @click="currencyOpen = true">
                <em class="mm-counter">2</em>
                <b-link
                  href="#"
                  title="Moneda"
                  class="mm-next"
                  style="width: 100%;"
                />
                <span class="mr-0">{{ $globalPrices[currency].symbol }}</span>
              </li>

              <li v-if="showLoggedInNavBarComponents">
                <span><a :href="`/${this.$store.state.main.lang}/bookings`">
                  {{ $t('lang.navbar.bookings') }}</a></span>
              </li>
              <li v-if="showLoggedInNavBarComponents">
                <span><a :href="`/${this.$store.state.main.lang}/account`">
                  {{ $t('lang.navbar.user_profile') }}</a></span>
              </li>

              <li v-if="showLoggedInNavBarComponents">
                <span>
                  <b-link
                    href="#"
                    @click="logout"
                  >{{ $t('lang.navbar.logout') }}
                  </b-link>
                </span>
              </li>

              <li v-if="!showLoggedInNavBarComponents && !showComingSoon">
                <span>
                  <b-link
                    href="#"
                    @click="setShowAuthModal('login')"
                  >{{ $t('lang.navbar.login') }}
                  </b-link>
                </span>
              </li>
              <li v-if="!showLoggedInNavBarComponents">
                <span>
                  <b-link
                    href="#"
                    @click="setShowAuthModal('register')"
                  >{{ $t('lang.navbar.register') }}
                  </b-link>

                </span>
              </li>
              <li>
                <span><a :href="`/${this.$store.state.main.lang}/full-help`">
                  {{ $t('lang.titles.help') }}
                </a></span>
              </li>
            </ul>
          </div>

          <div
            v-if="langOpen"
            class="mm-panel mm-hasnavbar mm-opened"
          >
            <div
              class="mm-navbar"
              @click="langOpen = false"
            >
              <b-link
                href="#"
                class="mm-btn mm-prev"
              />
              <b-link
                href="#"
                class="mm-title"
              >
                {{ $t('lang.navbar.language') }}
              </b-link>
            </div>

            <ul class="mm-listview">
              <li>
                <span><a @click="setPreferences('language','en')">
                  <img
                    src="../../assets/img/flags/england.png"
                    class="flag_icon"
                  >
                  English</a></span>
              </li>
              <li>
                <span><a @click="setPreferences('language','es')">
                  <img
                    src="../../assets/img/flags/spain.png"
                    class="flag_icon"
                  >
                  Español</a></span>
              </li>
              <li>
                <b-link
                  href="#"
                  @click="setPreferences('language','it')"
                >
                  <img
                    src="../../assets/img/flags/italy.png"
                    class="flag_icon"
                  >Italiano
                </b-link>
              </li>
              <li>
                <span><a @click="setPreferences('language','pt')">
                  <img
                    src="../../assets/img/flags/portugal.png"
                    class="flag_icon"
                  >
                  Português</a></span>
              </li>
            </ul>
          </div>

          <div
            v-if="currencyOpen"
            class="mm-panel mm-hasnavbar mm-opened"
          >
            <div
              class="mm-navbar"
              @click="currencyOpen = false"
            >
              <b-link
                href="#"
                class="mm-btn mm-prev"
              />

              <b-link
                href="#"
                class="mm-title"
              >
                {{ $t('lang.navbar.currency') }}
              </b-link>
            </div>

            <ul class="mm-listview">
              <li
                v-for="(currency_data, id) in $globalPrices"
                :key="id"
              >
                <b-link
                  href="#"
                  @click="setPreferences('currency',id)"
                >
                  <img
                    :src="currencyFlag(id)"
                    class="flag_icon"
                  >
                  <b class="pr-1">{{ currency_data.symbol }} </b>
                  <br>
                  {{ $t('lang.navbar.currency_'+id) }}
                </b-link>
              </li>
            </ul>
          </div>

          <div class="mm-navbars-bottom">
            <div class="mm-navbar mm-navbar-size-1">
              <b-link href="#">
                © WeKeep {{ (new Date()).getFullYear() }}
              </b-link>
            </div>
          </div>
        </div>
      </nav>

      <!-- Content inside this div make the side nav to push page content to the right
      (not used if you only want the sidenav to sit on top of the page -->
      <div
        id="main"
        :class="{'margin-left': isOpen}"
      >
        <b-link
          href="#"
          class="btn_mobile"
          aria-label="Menu"
          @click="showSidebar('hamburger')"
        >
          <div
            id="hamburger"
            class="hamburger hamburger--spin"
            :class="{'is-active': isOpen}"
          >
            <div class="hamburger-box">
              <div class="hamburger-inner" />
            </div>
          </div>
        </b-link>
      </div>
    </div>

    <div>
      <SocialChat />
    </div>
  </div>
</template>

<script>

import SocialChat from '@/components/ChatButtons';
import store from '@/stores/store';
import { API, errorResponse } from '../../api/api';

const AuthAPI = API.get('auth');

export default {
  name: 'NavBarComponents',

  components: {
    SocialChat,
  },

  props: {
    showComingSoon: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      showLoggedInNavBarComponents: false,
      isOpen: false,
      langOpen: false,
      currencyOpen: false,
      showNavBar: false,
    };
  },
  computed: {
    currency() {
      return this.$store.state.main.currency ? this.$store.state.main.currency : 'USD';
    },
  },

  created() {
    const { referral } = this.$route.query;
    if (referral) {
      this.$store.dispatch('setReferral', referral);
    }
  },

  async mounted() {
    const { query } = this.$route;

    if (query.app) {
      this.$store.dispatch('setApp', query.app);
    }

    let token = null;
    if (query.token) {
      token = query.token;
      this.$store.dispatch('setToken', query.token);
    } else {
      token = store.state.main.token;
    }

    // If there is a token on the storage, show navbar as logged in
    const { uuid } = store.state.main;
    if (token) {
      if (this.tokenIsValid(token)) {
        this.showLoggedInNavBarComponents = true;
      } else {
        // Clean storage
        this.$store.dispatch('removeUserData');
      }
    }

    if (!uuid) {
      // create a random id to identificate user before login
      try {
        this.$store.dispatch('setUUID', window.crypto.randomUUID());
      } catch (e) {
        console.log('Error creating random id');
      }
    }

    this.showNavBar = true;

    const { action } = this.$route.params;
    if (action === 'login' || action === 'register') {
      this.setShowAuthModal(action);
    }
  },
  methods: {

    setShowAuthModal(authToShow) {
      this.$store.dispatch('setAuthToShow', authToShow);
      this.$root.$emit('bv::show::modal', 'authModal');
      // GTAG Event
      dataLayer.push({
        event: 'open_auth_modal',
        source: 'navbar',
      });
      this.showSidebar('action');
    },

    tokenIsValid(token) {
      let tokenIsValid = false;

      try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map((c) => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`).join(''));
        const tokenObject = JSON.parse(jsonPayload);

        // If token is not expired
        if (tokenObject.exp > Date.now() / 1000) {
          tokenIsValid = true;
        }
      } catch (e) {

      }

      return tokenIsValid;
    },

    showSidebar(origin) {
      // when user clicks an option and navbar has to close.
      if (origin === 'action' && this.isOpen) {
        this.isOpen = false;
        document.getElementById('main').style.marginLeft = '0';
        document.getElementById('page').style.marginLeft = '0';
        document.getElementById('logo').style.marginLeft = '0';
      }

      // when user clicks open/close hamburger button.
      if (origin === 'hamburger') {
        if (this.isOpen) {
          this.isOpen = false;
          document.getElementById('main').style.marginLeft = '0';
          document.getElementById('page').style.marginLeft = '0';
          document.getElementById('logo').style.marginLeft = '0';
        } else {
          this.isOpen = true;
          if (window.screen.width <= 600) {
            document.getElementById('main').style.marginLeft = '150px';
            document.getElementById('page').style.marginLeft = '150px';
            document.getElementById('logo').style.marginLeft = '150px';
          } else {
            document.getElementById('main').style.marginLeft = '25%';
            document.getElementById('page').style.marginLeft = '25%';
            document.getElementById('logo').style.marginLeft = '25%';
          }
        }
      }
    },

    async logout() {
      this.errors = {};
      this.showSidebar('action');

      try {
        await AuthAPI.logOut();
        this.showLoggedInNavBarComponents = false;

        // Clean storage
        this.$store.dispatch('removeUserData');

        // Home redirect
        this.$router.push(`/${this.$store.state.main.lang}/`);
      } catch (error) {
        this.errors = errorResponse(error);
      }
    },

    setPreferences(type, value) {
      if (type === 'language') {
        let newPath = '';
        // CityHome no usa segmento de idioma, tiene el path traducido
        if (this.$route.name.includes('CityHome')) {
          this.$store.dispatch('setLanguage', value);
          this.$i18n.locale = value;
          newPath = `/${value}/${this.$t('lang.city_home.path')}/${this.$route.path.split('/')[3]}`;
        } else {
          // Copiamos la ruta actual y solo reemplazamos el segmento del idioma
          const segments = this.$route.path.split('/');
          segments[1] = value; // asumimos que el idioma es el primer segmento
          newPath = segments.join('/');
        }

        window.location.href = newPath;
      }
      if (type === 'currency') {
        this.$store.dispatch('setCurrency', value);
        if (this.$route.name.includes('Search')) {
          this.$router.go();
        }
      }

      this.showSidebar('action');
    },

    currencyFlag(id) {
      return require(`../../assets/img/flags/currency/${id}.png`);
    },
  },
};
</script>
